import { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Button } from 'react-bootstrap';
import PageTitle from '../../../common/page-title';
import { getScanOverrides, approveScanOverride, getScanOverridesCsv } from '../../../../actions/scans';
import ScanOverridesSearch from './scan-override-search';
import ScanOverridesTable from './scan-overrides-table';

class ScanOverridesPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      overrideRequestStatus: '',
      overrideRequestDateFrom: '',
      overrideRequestDateTo: '',
      page: 1
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getScanOverrides(''));
  }

  handleInputChange = (e) => {
    this.setState({ query: e.target.value });
  };

  handleStatusChange = (event) => {
    this.setState({ overrideRequestStatus: event.target.value });
  };

  handleDateFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ overrideRequestDateFrom: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ overrideRequestDateFrom: '' });
    }
  };

  handleDateToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ overrideRequestDateTo: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ overrideRequestDateTo: '' });
    }
  };

  handleSearch = () => {
    const { dispatch } = this.props;
    const {
      query, overrideRequestStatus, overrideRequestDateFrom, overrideRequestDateTo, page
    } = this.state;

    dispatch(getScanOverrides(query, overrideRequestStatus, overrideRequestDateFrom, overrideRequestDateTo, page));
  };

  handlePageChange = (page) => {
    this.setState({ page }, this.handleSearch);
  };

  handleClear = () => {
    this.setState({
      query: '',
      overrideRequestStatus: '',
      overrideRequestDateFrom: '',
      overrideRequestDateTo: '',
    }, this.handleSearch);
  };

  handleApprove = (id) => {
    const { dispatch } = this.props;

    dispatch(approveScanOverride(id));
  };

  handleCsvDownload = () => {
    const {
      query, overrideRequestStatus, overrideRequestDateFrom, overrideRequestDateTo
    } = this.state;

    getScanOverridesCsv(query, overrideRequestStatus, overrideRequestDateFrom, overrideRequestDateTo);
  };

  render() {
    const {
      paging, meta, loading, scans
    } = this.props;

    const {
      query, overrideRequestStatus, overrideRequestDateFrom, overrideRequestDateTo, page
    } = this.state;

    return (
      <div className="container-fluid">
        <Row>
          <PageTitle>Scan Override Requests</PageTitle>
          {loading ? 'Loading...' : (
            <div>
              <ScanOverridesSearch
                onClear={this.handleClear}
                onSearch={this.handleSearch}
                onInputChange={this.handleInputChange}
                searchValue={query}
                dateFromValue={overrideRequestDateFrom}
                dateToValue={overrideRequestDateTo}
                onDateFromChange={this.handleDateFromChange}
                onDateToChange={this.handleDateToChange}
                overrideRequestStatuses={meta['override-request-statuses']}
                overrideRequestStatus={overrideRequestStatus}
                onStatusChange={this.handleStatusChange}
              />
              <Button
                className="red-ghost-btn"
                onClick={this.handleCsvDownload}
              >
                Download scan override data
              </Button>
              <ScanOverridesTable
                scans={scans}
                currentPage={page}
                onPageChange={this.handlePageChange}
                onApprove={this.handleApprove}
                paging={paging}
              />
            </div>
          )}
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  scans: state.scans.scans,
  loading: !state.scans.fetched && state.scans.fetching,
  meta: state.scans.meta,
  paging: state.scans.paging,
});

export default connect(mapStateToProps)(ScanOverridesPage);
